import { Component, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { ClvService } from "src/app/_services/clv.service";
import { AppState } from "src/app/state/app.state";
import { asArray, Status, UserAction } from "src/app/enum";
import { ProductClvTableComponent } from "../product-management/product-clv-table.component";

@Component({
  selector: "warehouse-types-dialog",
  host: { class: "dialog" },
  templateUrl: "./warehouse-types.dialog.html"
})
export class WarehouseTypesDialog {
  public UserAction = UserAction;
  public statuses = asArray(Status);

  public form: FormGroup;
  public saveInProgress = false;

  private _parent: ProductClvTableComponent;
  private _data: any;

  public requiredRightsForEdit = [UserAction.ManageClvs];

  constructor(
    public appState: AppState,
    private _formBuilder: FormBuilder,
    private _clvService: ClvService,
    public dialogRef: MatDialogRef<WarehouseTypesDialog>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this._parent = this.dialogData.parent;
    this._data = this.dialogData.row || {};

    if (this.dialogData.requiredRightsForEdit) {
      this.requiredRightsForEdit = this.dialogData.requiredRightsForEdit;
    }

    const isNew = !this._data?.id;
    const dd = this._data?.deliveryDays || {};
    const deliveryDays = {
      Monday: isNew ? true : !!dd.Monday,
      Tuesday: isNew ? true : !!dd.Tuesday,
      Wednesday: isNew ? true : !!dd.Wednesday,
      Thursday: isNew ? true : !!dd.Thursday,
      Friday: isNew ? true : !!dd.Friday,
      Saturday: isNew ? true : !!dd.Saturday,
      Sunday: isNew ? true : !!dd.Sunday
    };

    this.form = this._formBuilder.group({
      classificatorId: new FormControl(this._parent.classificatorId),
      code: new FormControl(this._data.code),
      value: new FormControl(this._data.value),
      minOrderValue: new FormControl(this._data.minOrderValue),
      description: new FormControl(this._data.description),
      status: new FormControl(
        this._data.status === undefined ? Status.Active : this._data.status
      ),
      deliveryDays: new FormControl(deliveryDays),
      allowTodayDelivery: new FormControl(!!this._data.allowTodayDelivery)
    });
  }

  public get itemId() {
    return this._data?.id;
  }

  public get translationsPath(): string {
    return "cards.settings.product_management_settings.warehouse_types_edit";
  }

  private getData(): any {
    const f = this.form.value;
    const dd = this.form.get("deliveryDays")?.value || {};

    return {
      classificatorId: this._parent.classificatorId,
      code: f.code,
      value: f.value,
      minOrderValue: f.minOrderValue,
      description: f.description,
      status: f.status,
      allowTodayDelivery: !!f.allowTodayDelivery,
      deliveryDays: {
        Monday: !!dd.Monday,
        Tuesday: !!dd.Tuesday,
        Wednesday: !!dd.Wednesday,
        Thursday: !!dd.Thursday,
        Friday: !!dd.Friday,
        Saturday: !!dd.Saturday,
        Sunday: !!dd.Sunday
      }
    };
  }

  public save(): void {
    this.saveInProgress = true;
    const url = this._parent.baseUrl;

    this._clvService
      .save(url, this._data.id, this.getData())
      .pipe(
        finalize(() => {
          this.saveInProgress = false;
        })
      )
      .result(this.form, (response) => {
        this.dialogRef.close({
          response: response,
          form: this.form
        });
      });
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}

